import { ReliefBucket, ReliefCategory } from '@spike/activity-model';

// ---- Relief helpers (mirroring ActivityForm internals) ----

export interface ReliefSlotState {
    selected: boolean;
    count: number;
}

export interface ReliefCategoryState {
    enabled: boolean;
    morning: ReliefSlotState;
    afternoon: ReliefSlotState;
    evening: ReliefSlotState;
    note: string;
}

export const emptyReliefCategory = (): ReliefCategoryState => ({
    enabled: false,
    morning: { selected: true, count: 0 },
    afternoon: { selected: true, count: 0 },
    evening: { selected: true, count: 0 },
    note: ''
});

const slotFromValue = (value: number | null | undefined): ReliefSlotState =>
    value === null || value === undefined ? { selected: false, count: 0 } : { selected: true, count: value };

const slotToValue = (slot: ReliefSlotState): number | null => (slot.selected ? slot.count : null);

export const reliefCategoryFromBuckets = (
    buckets: Array<ReliefBucket> | undefined,
    type: ReliefCategory
): ReliefCategoryState => {
    const bucket = buckets?.find(b => b.type === type);

    if (!bucket) {
        return emptyReliefCategory();
    }

    return {
        enabled: true,
        morning: slotFromValue(bucket.morning),
        afternoon: slotFromValue(bucket.afternoon),
        evening: slotFromValue(bucket.evening),
        note: bucket.note ?? ''
    };
};

export const reliefCategorySelected = (cat: ReliefCategoryState): boolean =>
    cat.morning.selected || cat.afternoon.selected || cat.evening.selected;

export const reliefBucketFromCategory = (type: ReliefCategory, cat: ReliefCategoryState): ReliefBucket => ({
    type,
    morning: slotToValue(cat.morning),
    afternoon: slotToValue(cat.afternoon),
    evening: slotToValue(cat.evening),
    ...(cat.note.trim() ? { note: cat.note.trim() } : {})
});
